import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getJackpotView = (params) => {
    return axios.get(`${backendHost}/api/admin/jackpot/view`, {params});
};

export {
    getJackpotView
}